// @ts-nocheck
import { QqOutlined } from "@ant-design/icons";
import { h } from "preact";
import { useSelector } from "react-redux";
import { IRouteElement } from "../../../routes/interface";
import { navigateTo } from "../../../utils/navigation/navigation-services";
import { LinkItem, MenuItem } from "./styled";
interface IBaseMenu {
  item: IRouteElement;
  selectedMenu: string[];
}

const BaseMenu = (props: IBaseMenu) => {
  const { item, setSelectedMenu, selectedMenu } = props;
  const { PATH, KEY, TITLE, SEARCH, ICON, BADGE } = item;
  const changeDeviceCount = useSelector((state: any) => state.change.change?.length);

  const onPressRoute = () => {
    setSelectedMenu([KEY]);
    navigateTo({ pathname: PATH, search: SEARCH });
  };
  return (
    <MenuItem key={KEY} onClick={() => onPressRoute()}>
      {ICON ? <ICON /> : <QqOutlined />}
      <LinkItem active={selectedMenu[0] === KEY}>
        {TITLE}
        {BADGE && <BADGE changeDeviceCount={changeDeviceCount} />}
      </LinkItem>
    </MenuItem>
  );
};

export default BaseMenu;
